import { render, staticRenderFns } from "./SubscriptionPlanConfirmationModal.vue?vue&type=template&id=53cddafe"
import script from "./SubscriptionPlanConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./SubscriptionPlanConfirmationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports